import { FirmwareVersionInput } from "./FirmwareVersionInput"
import { Button, Col, Form } from "react-bootstrap"
import React, { useState } from "react"
import { ApiClient } from "../../ApiClient"
import { MessageType, useMessageReport } from "../MessageReporter"
import { useAuth0 } from "@auth0/auth0-react"
import { useNavigate } from "react-router-dom"
import { FirmwareUriBoardTypeInput } from "./FirmwareUriBoardTypeInput"

export const FirmwareBoardVersionCreate = () => {
    const { getAccessTokenSilently } = useAuth0()
    const { addMessage } = useMessageReport()
    const navigate = useNavigate()

    const [version, setVersion] = useState("")
    const [firmware, setFirmware] = useState({
        device: "",
        boardtype: "",
        uri: "",
    })
    const formValid =
        version !== "" && firmware.device !== "" && firmware.uri !== "" && firmware.boardtype !== ""

    const create = () => {
        const body = {
            type: "BOARDVERSION",
            version: version,
            device_type: firmware.device,
            board_type: firmware.boardtype,
            uri: firmware.uri,
        }

        getAccessTokenSilently()
            .then((token) =>
                ApiClient.post("/v2/management/firmwares", body, {
                    Authorization: "Bearer " + token,
                })
            )
            .then(({ headers }) => navigate("/firmware/" + headers.location))
            .catch((e) => {
                addMessage(
                    "Failed to add firmware",
                    "Something went wrong while updating the firmware, " +
                        "see the console for more details.",
                    MessageType.error,
                    e
                )
            })
    }

    return (
        <Col md={12}>
            <h2>Add board version</h2>
            <Form.Group className="mb-3">
                <Form.Label>Version</Form.Label>
                <FirmwareVersionInput setVersion={setVersion} />
            </Form.Group>

            <FirmwareUriBoardTypeInput setFirmware={setFirmware} />

            <Button disabled={!formValid} onClick={() => create()}>
                Create
            </Button>
        </Col>
    )
}
